import { useMouseParallax, useScrollParallax } from './modules/_fn.js'
import { useAccordion } from './modules/_components.js'
import { atom } from 'nanostores'

window.process = { env: { NODE_ENV: 'production' } }

const useConsultantsSwiper = () => {
	const swiperName = '.consultants__swiper'
	const swiperEl = document.querySelector(swiperName)

	if (!swiperEl) return

	return new Swiper(swiperEl, {
		speed: 700,
		slidesPerView: 'auto',
		spaceBetween: 24,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		breakpoints: {
			768: {
				spaceBetween: 40,
			},
			1024: {
				spaceBetween: 60,
			},
			1280: {
				spaceBetween: 80,
			},
			1440: {
				spaceBetween: 100,
			},
		},
		on: {
			breakpoint(swiper) {
				swiperEl.style.setProperty('--swiper-space-between', `${swiper.params.spaceBetween}px`)
			}
		}
	})
}

const useAccordionControl = () => {
	const accordionItems = [...document.querySelectorAll('.accordion-item')]
	const activeIndex = accordionItems.findIndex((item) => item.classList.contains('is-opened'))
	if (!accordionItems.length) return

	const $activeIndex = atom(activeIndex)

	accordionItems.forEach((item, index) => {
		const header = item.querySelector('.accordion-item__header')
		if (!header) return

		header.addEventListener('click', () => {
			$activeIndex.set(index)
		})
	})

	const imageEls = document.querySelectorAll('.features__aside__image img')

	$activeIndex.subscribe((index) => {
		if (!imageEls.length) return

		imageEls.forEach((el, i) => {
			el.classList.toggle('is-active', i === index)
		})
	})

	useAccordion()
}

document.addEventListener('DOMContentLoaded', () => {
	useMouseParallax()
	useScrollParallax()
	useAccordionControl()

	const consultantsSwiper = useConsultantsSwiper()
	if (!consultantsSwiper) return

	consultantsSwiper.autoplay.stop()

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				consultantsSwiper.autoplay.start()
				observer.unobserve(entry.target)
			}
		})
	})

	observer.observe(consultantsSwiper.el)
})
